import moment from 'moment-timezone';
import { isQuotaExceededError } from '../../helpers/isQuotaExceeded';
import ls from 'localstorage-slim';
import { LOCAL_STORAGE_TTL } from '../../constants/localStorage';

export const storeItemToLog = (text: string, obj: object, matchId: number, requestId: string) => {
  const time = moment.tz(new Date(), 'Europe/Oslo').format();
  const key = `${matchId}.log`;
  let storedLog = ls.get(key) as string;
  if (!storedLog) {
    storedLog = '';
  }
  storedLog += text + '. Request id: ' + requestId + ', time:' + time + ':\n' + JSON.stringify(obj) + '\n\n';
  try {
    ls.set(key, storedLog, { ttl: LOCAL_STORAGE_TTL });
  } catch (e) {
    console.log('Error in local storage', e);
    if (isQuotaExceededError(e)) {
      ls.flush();
      try {
        ls.set(key, storedLog, { ttl: LOCAL_STORAGE_TTL });
      } catch (e) {
        console.log('Error (2nd) in local storage', e);
      }
    }
  }
  window.dispatchEvent(new Event('storage'));
};
